import React from 'react';
import { useDispatch } from 'react-redux';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MenuButton from '@/components/common/MenuButton';
import FeedContentType from '@/constants/FeedContentType';
import MultiActionDialogKey from '@/constants/MultiActionDialogKey';
import { useCurrentUser } from '@/lib/hooks/userData';
import translate from '@/lib/intl/translate';
import userActionTypes from '@/rdx/actionTypes';

type InteractionMenuProps = {
  interaction: {
    interactionId?: string;
  };
};

function InteractionMenu({ interaction }: InteractionMenuProps) {
  const { isOrgAdmin, isOrgEditor } = useCurrentUser();
  const id = 'feed-slider-menu';
  const [menuAnchor, setMenuAnchor] = React.useState(null);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO(ts-migrate)
  const openMenu = (e: any) => setMenuAnchor(e.currentTarget);
  const closeMenu = () => setMenuAnchor(null);
  const dispatch = useDispatch();
  const items = [
    {
      label: translate('EDIT'),
      onClick: () => {
        dispatch({
          type: userActionTypes.OPEN_ACTION_DIALOG,
          dialogKey: MultiActionDialogKey.INTERACTION,
          data: interaction,
        });
        setMenuAnchor(null);
      },
    },
    {
      label: translate('DELETE'),
      onClick: () => {
        dispatch({
          type: userActionTypes.OPEN_ACTION_DIALOG,
          dialogKey: MultiActionDialogKey.DELETE_FEED_ITEM_CONFIRMATION,
          config: {
            entityType: FeedContentType.INTERACTION,
            title: translate('DELETE_INTERACTION_TITLE'),
            label: translate('DELETE_INTERACTION_LABEL'),
          },
          data: { contentId: interaction.interactionId },
        });
        setMenuAnchor(null);
      },
    },
  ];
  const showControls = items.length && (isOrgAdmin || isOrgEditor);

  return showControls ? (
    <>
      <MenuButton
        onClick={openMenu}
        className="ml-4 text-text-secondary"
        aria-controls={menuAnchor ? id : undefined}
        aria-haspopup="true"
      />
      <Menu
        id={id}
        onClose={closeMenu}
        open={!!menuAnchor}
        anchorEl={menuAnchor}
      >
        {items.map(({ label, onClick }) => (
          <MenuItem key={label} onClick={onClick}>
            {label}
          </MenuItem>
        ))}
      </Menu>
    </>
  ) : null;
}

export default InteractionMenu;
